import * as Types from '@coverright/data-access/types/enrollment';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteOfflineConversionSyncProcessMutationVariables = Types.Exact<{
  id: Types.Scalars['Long']['input'];
}>;


export type DeleteOfflineConversionSyncProcessMutation = { __typename?: 'Mutation', deleteOfflineConversionSyncProcess: boolean };

export type OfflineConversionSyncProcessesQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.OfflineConversionSyncProcessFilterInput>;
  page: Types.PageInput;
}>;


export type OfflineConversionSyncProcessesQuery = { __typename?: 'Query', offlineConversionSyncProcesses: { __typename?: 'PageableOfflineConversionSyncProcessOutput', totalElements: any, data: Array<{ __typename?: 'OfflineConversionSyncProcessOutput', cId?: string | null, clientId: any, conversionTime: any, createdAt: any, errorMsg?: string | null, eventName: Types.EventName, fbclid?: string | null, gbraid?: string | null, gclid?: string | null, id: any, msclkid?: string | null, platform?: Types.Platform | null, synced: boolean, uId?: string | null, updatedAt: any, utmBrand?: string | null, utmCampaign?: string | null, utmContent?: string | null, utmMedium?: string | null, utmSource?: string | null, utmTerm?: string | null, version: any, wbraid?: string | null }> } };

export type SyncOfflineConversionsMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type SyncOfflineConversionsMutation = { __typename?: 'Mutation', syncOfflineConversions: boolean };

export type UpdatedUserProfileByAdvisorMutationVariables = Types.Exact<{
  clientId: Types.Scalars['UUID']['input'];
  input: Types.UserProfileInputForAdviserInput;
}>;


export type UpdatedUserProfileByAdvisorMutation = { __typename?: 'Mutation', updatedUserProfileByAdvisor: boolean };

export type LinkAdviserWithClientMutationVariables = Types.Exact<{
  email: Types.Scalars['String']['input'];
}>;


export type LinkAdviserWithClientMutation = { __typename?: 'Mutation', linkAdviserWithClient: boolean };

export type CheckUserExistenceByEmailQueryVariables = Types.Exact<{
  email: Types.Scalars['String']['input'];
}>;


export type CheckUserExistenceByEmailQuery = { __typename?: 'Query', checkUserExistenceByEmail: boolean };

export type PingSubscriptionVariables = Types.Exact<{ [key: string]: never; }>;


export type PingSubscription = { __typename?: 'Subscription', ping: any };

export type ClientViewForAdviserQueryVariables = Types.Exact<{
  clientId: Types.Scalars['UUID']['input'];
}>;


export type ClientViewForAdviserQuery = { __typename?: 'Query', clientViewForAdviser?: { __typename?: 'ClientViewForAdviserOutput', agentCalendlyUrl?: string | null, appointmentAttended?: boolean | null, appointmentStartAt?: any | null, assignedAgentEmail?: string | null, assignedAgentName?: string | null, birthDate?: any | null, callScheduled?: boolean | null, clientId: any, countyName?: string | null, createdAt?: any | null, email?: string | null, enrollmentCarrier?: string | null, enrollmentEffectiveDate?: any | null, enrollmentPlanName?: string | null, enrollmentType?: string | null, enrollmentWritingAgentEmail?: string | null, firstName?: string | null, gender?: string | null, hasAppointment: boolean, hasEnrollment: boolean, lastName?: string | null, medigapQuoteId?: any | null, pdpQuoteId?: any | null, quoteCreated?: boolean | null, quoteId?: any | null, state?: string | null, tobacco?: boolean | null, zip?: string | null } | null };

export type RequestUrgentCallMutationVariables = Types.Exact<{
  urgentCallType: Types.UrgentCallTypeDto;
}>;


export type RequestUrgentCallMutation = { __typename?: 'Mutation', requestUrgentCall: boolean };

export type MyClientIdQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type MyClientIdQuery = { __typename?: 'Query', myClientId: any };

export type EmailMeMedigapPageMutationVariables = Types.Exact<{
  email: Types.Scalars['String']['input'];
  id: Types.Scalars['UUID']['input'];
}>;


export type EmailMeMedigapPageMutation = { __typename?: 'Mutation', emailMeMedigapPage: boolean };

export type EmailMeMaPageMutationVariables = Types.Exact<{
  email: Types.Scalars['String']['input'];
  id: Types.Scalars['UUID']['input'];
  yearEmailMeMaPage?: Types.InputMaybe<Types.EmailMeMaPagePlanYear>;
}>;


export type EmailMeMaPageMutation = { __typename?: 'Mutation', emailMeMAPage: boolean };

export type NerdWalletUserProfileQueryVariables = Types.Exact<{
  nerdWalletId: Types.Scalars['String']['input'];
}>;


export type NerdWalletUserProfileQuery = { __typename?: 'Query', nerdWalletUserProfile?: { __typename?: 'UserProfileOutput', tobacco?: boolean | null, birthDate?: any | null, email?: string | null, firstName?: string | null, gender?: string | null, lastName?: string | null, phoneNumber?: string | null, quoteId?: any | null, pdpQuoteId?: any | null, medigapQuoteId?: any | null, state?: string | null, userId?: any | null, zip?: string | null, countyName?: string | null, profileId: any, clientId?: any | null, eligibleName?: string | null, medicareNumber?: string | null, medicarePartAStartedAt?: string | null, medicarePartBStartedAt?: string | null, age?: number | null, fullName?: string | null } | null };

export type ClientCardSubscriptionVariables = Types.Exact<{
  clientId: Types.Scalars['UUID']['input'];
}>;


export type ClientCardSubscription = { __typename?: 'Subscription', clientCard: { __typename?: 'ClientViewOutput', id: any, countyName?: string | null, customAnswers?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, gender?: string | null, tobacco?: boolean | null, phoneNumber?: string | null, pin?: string | null, profileId?: any | null, quoteId?: any | null, status: Types.StatusDto, birthDate?: any | null, zip?: string | null, state?: string | null, scopeOfAppointmentStatus?: Types.ScopeOfAppointmentStatusDto | null, agentMedicareQuote?: { __typename?: 'MedicareQuoteOutput', agentOffer?: boolean | null, cId?: string | null, countyName?: string | null, createdAt?: any | null, pin?: string | null, quoteId: any, state?: string | null, userId?: any | null, zip?: string | null } | null, agentMedigapQuote?: { __typename?: 'MedigapQuoteViewOutput', cId?: string | null, createdAt?: any | null, id: any, updatedAt?: any | null, userId?: any | null } | null, medigapQuote?: { __typename?: 'MedigapQuoteViewOutput', id: any, createdAt?: any | null } | null, pdpQuote?: { __typename?: 'PdpQuoteOutput', id: any } | null } };

export type PatchClientPersonalInfoMutationVariables = Types.Exact<{
  clientId: Types.Scalars['UUID']['input'];
  preferredDrugs?: Types.InputMaybe<Array<Types.PreferredDrugInput> | Types.PreferredDrugInput>;
  preferredPharmacies?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
  drugDeliveryType?: Types.InputMaybe<Types.ClientDrugDeliveryType>;
}>;


export type PatchClientPersonalInfoMutation = { __typename?: 'Mutation', patchClientPersonalInfo: boolean };

export type CalendlyInviteeQueryVariables = Types.Exact<{
  eventUrl: Types.Scalars['String']['input'];
  inviteeUrl: Types.Scalars['String']['input'];
}>;


export type CalendlyInviteeQuery = { __typename?: 'Query', calendlyInvitee: { __typename?: 'InviteePersonalInfoOutput', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null } };

export type UserProfileQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UserProfileQuery = { __typename?: 'Query', userProfile?: { __typename?: 'UserProfileOutput', tobacco?: boolean | null, birthDate?: any | null, email?: string | null, firstName?: string | null, gender?: string | null, lastName?: string | null, phoneNumber?: string | null, quoteId?: any | null, pdpQuoteId?: any | null, medigapQuoteId?: any | null, state?: string | null, userId?: any | null, zip?: string | null, countyName?: string | null, profileId: any, clientId?: any | null, eligibleName?: string | null, medicareNumber?: string | null, medicarePartAStartedAt?: string | null, medicarePartBStartedAt?: string | null, age?: number | null, fullName?: string | null } | null };

export type UserProfileFieldsFragment = { __typename?: 'UserProfileOutput', tobacco?: boolean | null, birthDate?: any | null, email?: string | null, firstName?: string | null, gender?: string | null, lastName?: string | null, phoneNumber?: string | null, quoteId?: any | null, pdpQuoteId?: any | null, medigapQuoteId?: any | null, state?: string | null, userId?: any | null, zip?: string | null, countyName?: string | null, profileId: any, clientId?: any | null, eligibleName?: string | null, medicareNumber?: string | null, medicarePartAStartedAt?: string | null, medicarePartBStartedAt?: string | null, age?: number | null, fullName?: string | null };

export type AgentByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
}>;


export type AgentByIdQuery = { __typename?: 'Query', agentById: { __typename?: 'AgentOutput', b2bMeetingUrl?: string | null, email: string, firstName: string, id: any, lastName: string, picUrl?: string | null, phone?: string | null, enrollmentMeetingUrl?: string | null, planReviewUrl?: string | null, consultationUrl?: string | null } };

export type AgentAssignedToClientQueryVariables = Types.Exact<{
  clientId: Types.Scalars['UUID']['input'];
}>;


export type AgentAssignedToClientQuery = { __typename?: 'Query', agentAssignedToClient: { __typename?: 'AgentViewOutput', email: string, firstName: string, id: any, lastName: string, picUrl?: string | null, phone?: string | null, enrollmentMeetingUrl?: string | null, planReviewUrl?: string | null, consultationUrl?: string | null } };

export type SaveUserProfileMutationVariables = Types.Exact<{
  data: Types.UserProfileInput;
}>;


export type SaveUserProfileMutation = { __typename?: 'Mutation', saveUserProfile: { __typename?: 'UserProfileSaveOutput', enrollmentId?: any | null, profileId: any, userId?: any | null, clientId?: any | null, userToken?: { __typename?: 'UserToken', accessToken: string, idToken: string, refreshToken: string } | null } };

export type SetNewPasswordMutationVariables = Types.Exact<{
  newPassword: Types.Scalars['String']['input'];
}>;


export type SetNewPasswordMutation = { __typename?: 'Mutation', setNewPassword: boolean };

export type HasEnrollmentsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type HasEnrollmentsQuery = { __typename?: 'Query', hasEnrollments: boolean };

export type MyEnrollmentsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type MyEnrollmentsQuery = { __typename?: 'Query', myEnrollments: Array<{ __typename?: 'EnrollmentListItemOutput', applicationDate?: any | null, bidId?: string | null, carrierName?: string | null, effectiveDate?: any | null, enrollmentType?: string | null, mgPlanKey?: string | null, mgPlanName?: string | null, naic?: string | null, planName?: string | null, planYear?: string | null, type: Types.EnrollmentType, id: any, zip?: string | null, county?: string | null }> };

export const UserProfileFieldsFragmentDoc = gql`
    fragment UserProfileFields on UserProfileOutput {
  tobacco
  birthDate
  email
  firstName
  gender
  lastName
  phoneNumber
  quoteId
  pdpQuoteId
  medigapQuoteId
  state
  userId
  zip
  countyName
  profileId
  clientId
  eligibleName
  medicareNumber
  medicarePartAStartedAt
  medicarePartBStartedAt
  age @client
  fullName @client
}
    `;
export const DeleteOfflineConversionSyncProcessDocument = gql`
    mutation deleteOfflineConversionSyncProcess($id: Long!) {
  deleteOfflineConversionSyncProcess(id: $id)
}
    `;
export type DeleteOfflineConversionSyncProcessMutationFn = Apollo.MutationFunction<DeleteOfflineConversionSyncProcessMutation, DeleteOfflineConversionSyncProcessMutationVariables>;

/**
 * __useDeleteOfflineConversionSyncProcessMutation__
 *
 * To run a mutation, you first call `useDeleteOfflineConversionSyncProcessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOfflineConversionSyncProcessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOfflineConversionSyncProcessMutation, { data, loading, error }] = useDeleteOfflineConversionSyncProcessMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOfflineConversionSyncProcessMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOfflineConversionSyncProcessMutation, DeleteOfflineConversionSyncProcessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOfflineConversionSyncProcessMutation, DeleteOfflineConversionSyncProcessMutationVariables>(DeleteOfflineConversionSyncProcessDocument, options);
      }
export type DeleteOfflineConversionSyncProcessMutationHookResult = ReturnType<typeof useDeleteOfflineConversionSyncProcessMutation>;
export type DeleteOfflineConversionSyncProcessMutationResult = Apollo.MutationResult<DeleteOfflineConversionSyncProcessMutation>;
export type DeleteOfflineConversionSyncProcessMutationOptions = Apollo.BaseMutationOptions<DeleteOfflineConversionSyncProcessMutation, DeleteOfflineConversionSyncProcessMutationVariables>;
export const OfflineConversionSyncProcessesDocument = gql`
    query offlineConversionSyncProcesses($filter: OfflineConversionSyncProcessFilterInput, $page: PageInput!) {
  offlineConversionSyncProcesses(page: $page, filter: $filter) {
    data {
      cId
      clientId
      conversionTime
      createdAt
      errorMsg
      eventName
      fbclid
      gbraid
      gclid
      id
      msclkid
      platform
      synced
      uId
      updatedAt
      utmBrand
      utmCampaign
      utmContent
      utmMedium
      utmSource
      utmTerm
      version
      wbraid
    }
    totalElements
  }
}
    `;

/**
 * __useOfflineConversionSyncProcessesQuery__
 *
 * To run a query within a React component, call `useOfflineConversionSyncProcessesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfflineConversionSyncProcessesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfflineConversionSyncProcessesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useOfflineConversionSyncProcessesQuery(baseOptions: Apollo.QueryHookOptions<OfflineConversionSyncProcessesQuery, OfflineConversionSyncProcessesQueryVariables> & ({ variables: OfflineConversionSyncProcessesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OfflineConversionSyncProcessesQuery, OfflineConversionSyncProcessesQueryVariables>(OfflineConversionSyncProcessesDocument, options);
      }
export function useOfflineConversionSyncProcessesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OfflineConversionSyncProcessesQuery, OfflineConversionSyncProcessesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OfflineConversionSyncProcessesQuery, OfflineConversionSyncProcessesQueryVariables>(OfflineConversionSyncProcessesDocument, options);
        }
export function useOfflineConversionSyncProcessesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OfflineConversionSyncProcessesQuery, OfflineConversionSyncProcessesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OfflineConversionSyncProcessesQuery, OfflineConversionSyncProcessesQueryVariables>(OfflineConversionSyncProcessesDocument, options);
        }
export type OfflineConversionSyncProcessesQueryHookResult = ReturnType<typeof useOfflineConversionSyncProcessesQuery>;
export type OfflineConversionSyncProcessesLazyQueryHookResult = ReturnType<typeof useOfflineConversionSyncProcessesLazyQuery>;
export type OfflineConversionSyncProcessesSuspenseQueryHookResult = ReturnType<typeof useOfflineConversionSyncProcessesSuspenseQuery>;
export type OfflineConversionSyncProcessesQueryResult = Apollo.QueryResult<OfflineConversionSyncProcessesQuery, OfflineConversionSyncProcessesQueryVariables>;
export const SyncOfflineConversionsDocument = gql`
    mutation syncOfflineConversions {
  syncOfflineConversions
}
    `;
export type SyncOfflineConversionsMutationFn = Apollo.MutationFunction<SyncOfflineConversionsMutation, SyncOfflineConversionsMutationVariables>;

/**
 * __useSyncOfflineConversionsMutation__
 *
 * To run a mutation, you first call `useSyncOfflineConversionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncOfflineConversionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncOfflineConversionsMutation, { data, loading, error }] = useSyncOfflineConversionsMutation({
 *   variables: {
 *   },
 * });
 */
export function useSyncOfflineConversionsMutation(baseOptions?: Apollo.MutationHookOptions<SyncOfflineConversionsMutation, SyncOfflineConversionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncOfflineConversionsMutation, SyncOfflineConversionsMutationVariables>(SyncOfflineConversionsDocument, options);
      }
export type SyncOfflineConversionsMutationHookResult = ReturnType<typeof useSyncOfflineConversionsMutation>;
export type SyncOfflineConversionsMutationResult = Apollo.MutationResult<SyncOfflineConversionsMutation>;
export type SyncOfflineConversionsMutationOptions = Apollo.BaseMutationOptions<SyncOfflineConversionsMutation, SyncOfflineConversionsMutationVariables>;
export const UpdatedUserProfileByAdvisorDocument = gql`
    mutation updatedUserProfileByAdvisor($clientId: UUID!, $input: UserProfileInputForAdviserInput!) {
  updatedUserProfileByAdvisor(clientId: $clientId, input: $input)
}
    `;
export type UpdatedUserProfileByAdvisorMutationFn = Apollo.MutationFunction<UpdatedUserProfileByAdvisorMutation, UpdatedUserProfileByAdvisorMutationVariables>;

/**
 * __useUpdatedUserProfileByAdvisorMutation__
 *
 * To run a mutation, you first call `useUpdatedUserProfileByAdvisorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatedUserProfileByAdvisorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatedUserProfileByAdvisorMutation, { data, loading, error }] = useUpdatedUserProfileByAdvisorMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatedUserProfileByAdvisorMutation(baseOptions?: Apollo.MutationHookOptions<UpdatedUserProfileByAdvisorMutation, UpdatedUserProfileByAdvisorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatedUserProfileByAdvisorMutation, UpdatedUserProfileByAdvisorMutationVariables>(UpdatedUserProfileByAdvisorDocument, options);
      }
export type UpdatedUserProfileByAdvisorMutationHookResult = ReturnType<typeof useUpdatedUserProfileByAdvisorMutation>;
export type UpdatedUserProfileByAdvisorMutationResult = Apollo.MutationResult<UpdatedUserProfileByAdvisorMutation>;
export type UpdatedUserProfileByAdvisorMutationOptions = Apollo.BaseMutationOptions<UpdatedUserProfileByAdvisorMutation, UpdatedUserProfileByAdvisorMutationVariables>;
export const LinkAdviserWithClientDocument = gql`
    mutation linkAdviserWithClient($email: String!) {
  linkAdviserWithClient(email: $email)
}
    `;
export type LinkAdviserWithClientMutationFn = Apollo.MutationFunction<LinkAdviserWithClientMutation, LinkAdviserWithClientMutationVariables>;

/**
 * __useLinkAdviserWithClientMutation__
 *
 * To run a mutation, you first call `useLinkAdviserWithClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkAdviserWithClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkAdviserWithClientMutation, { data, loading, error }] = useLinkAdviserWithClientMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useLinkAdviserWithClientMutation(baseOptions?: Apollo.MutationHookOptions<LinkAdviserWithClientMutation, LinkAdviserWithClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkAdviserWithClientMutation, LinkAdviserWithClientMutationVariables>(LinkAdviserWithClientDocument, options);
      }
export type LinkAdviserWithClientMutationHookResult = ReturnType<typeof useLinkAdviserWithClientMutation>;
export type LinkAdviserWithClientMutationResult = Apollo.MutationResult<LinkAdviserWithClientMutation>;
export type LinkAdviserWithClientMutationOptions = Apollo.BaseMutationOptions<LinkAdviserWithClientMutation, LinkAdviserWithClientMutationVariables>;
export const CheckUserExistenceByEmailDocument = gql`
    query checkUserExistenceByEmail($email: String!) {
  checkUserExistenceByEmail(email: $email)
}
    `;

/**
 * __useCheckUserExistenceByEmailQuery__
 *
 * To run a query within a React component, call `useCheckUserExistenceByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckUserExistenceByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckUserExistenceByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useCheckUserExistenceByEmailQuery(baseOptions: Apollo.QueryHookOptions<CheckUserExistenceByEmailQuery, CheckUserExistenceByEmailQueryVariables> & ({ variables: CheckUserExistenceByEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckUserExistenceByEmailQuery, CheckUserExistenceByEmailQueryVariables>(CheckUserExistenceByEmailDocument, options);
      }
export function useCheckUserExistenceByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckUserExistenceByEmailQuery, CheckUserExistenceByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckUserExistenceByEmailQuery, CheckUserExistenceByEmailQueryVariables>(CheckUserExistenceByEmailDocument, options);
        }
export function useCheckUserExistenceByEmailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckUserExistenceByEmailQuery, CheckUserExistenceByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckUserExistenceByEmailQuery, CheckUserExistenceByEmailQueryVariables>(CheckUserExistenceByEmailDocument, options);
        }
export type CheckUserExistenceByEmailQueryHookResult = ReturnType<typeof useCheckUserExistenceByEmailQuery>;
export type CheckUserExistenceByEmailLazyQueryHookResult = ReturnType<typeof useCheckUserExistenceByEmailLazyQuery>;
export type CheckUserExistenceByEmailSuspenseQueryHookResult = ReturnType<typeof useCheckUserExistenceByEmailSuspenseQuery>;
export type CheckUserExistenceByEmailQueryResult = Apollo.QueryResult<CheckUserExistenceByEmailQuery, CheckUserExistenceByEmailQueryVariables>;
export const PingDocument = gql`
    subscription ping {
  ping
}
    `;

/**
 * __usePingSubscription__
 *
 * To run a query within a React component, call `usePingSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePingSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePingSubscription({
 *   variables: {
 *   },
 * });
 */
export function usePingSubscription(baseOptions?: Apollo.SubscriptionHookOptions<PingSubscription, PingSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<PingSubscription, PingSubscriptionVariables>(PingDocument, options);
      }
export type PingSubscriptionHookResult = ReturnType<typeof usePingSubscription>;
export type PingSubscriptionResult = Apollo.SubscriptionResult<PingSubscription>;
export const ClientViewForAdviserDocument = gql`
    query clientViewForAdviser($clientId: UUID!) {
  clientViewForAdviser(clientId: $clientId) {
    agentCalendlyUrl
    appointmentAttended
    appointmentStartAt
    assignedAgentEmail
    assignedAgentName
    birthDate
    callScheduled
    clientId
    countyName
    createdAt
    email
    enrollmentCarrier
    enrollmentEffectiveDate
    enrollmentPlanName
    enrollmentType
    enrollmentWritingAgentEmail
    firstName
    gender
    hasAppointment
    hasEnrollment
    lastName
    medigapQuoteId
    pdpQuoteId
    quoteCreated
    quoteId
    state
    tobacco
    zip
  }
}
    `;

/**
 * __useClientViewForAdviserQuery__
 *
 * To run a query within a React component, call `useClientViewForAdviserQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientViewForAdviserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientViewForAdviserQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useClientViewForAdviserQuery(baseOptions: Apollo.QueryHookOptions<ClientViewForAdviserQuery, ClientViewForAdviserQueryVariables> & ({ variables: ClientViewForAdviserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientViewForAdviserQuery, ClientViewForAdviserQueryVariables>(ClientViewForAdviserDocument, options);
      }
export function useClientViewForAdviserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientViewForAdviserQuery, ClientViewForAdviserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientViewForAdviserQuery, ClientViewForAdviserQueryVariables>(ClientViewForAdviserDocument, options);
        }
export function useClientViewForAdviserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ClientViewForAdviserQuery, ClientViewForAdviserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClientViewForAdviserQuery, ClientViewForAdviserQueryVariables>(ClientViewForAdviserDocument, options);
        }
export type ClientViewForAdviserQueryHookResult = ReturnType<typeof useClientViewForAdviserQuery>;
export type ClientViewForAdviserLazyQueryHookResult = ReturnType<typeof useClientViewForAdviserLazyQuery>;
export type ClientViewForAdviserSuspenseQueryHookResult = ReturnType<typeof useClientViewForAdviserSuspenseQuery>;
export type ClientViewForAdviserQueryResult = Apollo.QueryResult<ClientViewForAdviserQuery, ClientViewForAdviserQueryVariables>;
export const RequestUrgentCallDocument = gql`
    mutation requestUrgentCall($urgentCallType: UrgentCallTypeDto!) {
  requestUrgentCall(urgentCallType: $urgentCallType)
}
    `;
export type RequestUrgentCallMutationFn = Apollo.MutationFunction<RequestUrgentCallMutation, RequestUrgentCallMutationVariables>;

/**
 * __useRequestUrgentCallMutation__
 *
 * To run a mutation, you first call `useRequestUrgentCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestUrgentCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestUrgentCallMutation, { data, loading, error }] = useRequestUrgentCallMutation({
 *   variables: {
 *      urgentCallType: // value for 'urgentCallType'
 *   },
 * });
 */
export function useRequestUrgentCallMutation(baseOptions?: Apollo.MutationHookOptions<RequestUrgentCallMutation, RequestUrgentCallMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestUrgentCallMutation, RequestUrgentCallMutationVariables>(RequestUrgentCallDocument, options);
      }
export type RequestUrgentCallMutationHookResult = ReturnType<typeof useRequestUrgentCallMutation>;
export type RequestUrgentCallMutationResult = Apollo.MutationResult<RequestUrgentCallMutation>;
export type RequestUrgentCallMutationOptions = Apollo.BaseMutationOptions<RequestUrgentCallMutation, RequestUrgentCallMutationVariables>;
export const MyClientIdDocument = gql`
    query myClientId {
  myClientId
}
    `;

/**
 * __useMyClientIdQuery__
 *
 * To run a query within a React component, call `useMyClientIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyClientIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyClientIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyClientIdQuery(baseOptions?: Apollo.QueryHookOptions<MyClientIdQuery, MyClientIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyClientIdQuery, MyClientIdQueryVariables>(MyClientIdDocument, options);
      }
export function useMyClientIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyClientIdQuery, MyClientIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyClientIdQuery, MyClientIdQueryVariables>(MyClientIdDocument, options);
        }
export function useMyClientIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyClientIdQuery, MyClientIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyClientIdQuery, MyClientIdQueryVariables>(MyClientIdDocument, options);
        }
export type MyClientIdQueryHookResult = ReturnType<typeof useMyClientIdQuery>;
export type MyClientIdLazyQueryHookResult = ReturnType<typeof useMyClientIdLazyQuery>;
export type MyClientIdSuspenseQueryHookResult = ReturnType<typeof useMyClientIdSuspenseQuery>;
export type MyClientIdQueryResult = Apollo.QueryResult<MyClientIdQuery, MyClientIdQueryVariables>;
export const EmailMeMedigapPageDocument = gql`
    mutation emailMeMedigapPage($email: String!, $id: UUID!) {
  emailMeMedigapPage(email: $email, id: $id)
}
    `;
export type EmailMeMedigapPageMutationFn = Apollo.MutationFunction<EmailMeMedigapPageMutation, EmailMeMedigapPageMutationVariables>;

/**
 * __useEmailMeMedigapPageMutation__
 *
 * To run a mutation, you first call `useEmailMeMedigapPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailMeMedigapPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailMeMedigapPageMutation, { data, loading, error }] = useEmailMeMedigapPageMutation({
 *   variables: {
 *      email: // value for 'email'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEmailMeMedigapPageMutation(baseOptions?: Apollo.MutationHookOptions<EmailMeMedigapPageMutation, EmailMeMedigapPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmailMeMedigapPageMutation, EmailMeMedigapPageMutationVariables>(EmailMeMedigapPageDocument, options);
      }
export type EmailMeMedigapPageMutationHookResult = ReturnType<typeof useEmailMeMedigapPageMutation>;
export type EmailMeMedigapPageMutationResult = Apollo.MutationResult<EmailMeMedigapPageMutation>;
export type EmailMeMedigapPageMutationOptions = Apollo.BaseMutationOptions<EmailMeMedigapPageMutation, EmailMeMedigapPageMutationVariables>;
export const EmailMeMaPageDocument = gql`
    mutation emailMeMAPage($email: String!, $id: UUID!, $yearEmailMeMaPage: EmailMeMaPagePlanYear) {
  emailMeMAPage(email: $email, id: $id, yearEmailMeMaPage: $yearEmailMeMaPage)
}
    `;
export type EmailMeMaPageMutationFn = Apollo.MutationFunction<EmailMeMaPageMutation, EmailMeMaPageMutationVariables>;

/**
 * __useEmailMeMaPageMutation__
 *
 * To run a mutation, you first call `useEmailMeMaPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailMeMaPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailMeMaPageMutation, { data, loading, error }] = useEmailMeMaPageMutation({
 *   variables: {
 *      email: // value for 'email'
 *      id: // value for 'id'
 *      yearEmailMeMaPage: // value for 'yearEmailMeMaPage'
 *   },
 * });
 */
export function useEmailMeMaPageMutation(baseOptions?: Apollo.MutationHookOptions<EmailMeMaPageMutation, EmailMeMaPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmailMeMaPageMutation, EmailMeMaPageMutationVariables>(EmailMeMaPageDocument, options);
      }
export type EmailMeMaPageMutationHookResult = ReturnType<typeof useEmailMeMaPageMutation>;
export type EmailMeMaPageMutationResult = Apollo.MutationResult<EmailMeMaPageMutation>;
export type EmailMeMaPageMutationOptions = Apollo.BaseMutationOptions<EmailMeMaPageMutation, EmailMeMaPageMutationVariables>;
export const NerdWalletUserProfileDocument = gql`
    query nerdWalletUserProfile($nerdWalletId: String!) {
  nerdWalletUserProfile(nerdWalletId: $nerdWalletId) {
    ...UserProfileFields
  }
}
    ${UserProfileFieldsFragmentDoc}`;

/**
 * __useNerdWalletUserProfileQuery__
 *
 * To run a query within a React component, call `useNerdWalletUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useNerdWalletUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNerdWalletUserProfileQuery({
 *   variables: {
 *      nerdWalletId: // value for 'nerdWalletId'
 *   },
 * });
 */
export function useNerdWalletUserProfileQuery(baseOptions: Apollo.QueryHookOptions<NerdWalletUserProfileQuery, NerdWalletUserProfileQueryVariables> & ({ variables: NerdWalletUserProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NerdWalletUserProfileQuery, NerdWalletUserProfileQueryVariables>(NerdWalletUserProfileDocument, options);
      }
export function useNerdWalletUserProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NerdWalletUserProfileQuery, NerdWalletUserProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NerdWalletUserProfileQuery, NerdWalletUserProfileQueryVariables>(NerdWalletUserProfileDocument, options);
        }
export function useNerdWalletUserProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NerdWalletUserProfileQuery, NerdWalletUserProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NerdWalletUserProfileQuery, NerdWalletUserProfileQueryVariables>(NerdWalletUserProfileDocument, options);
        }
export type NerdWalletUserProfileQueryHookResult = ReturnType<typeof useNerdWalletUserProfileQuery>;
export type NerdWalletUserProfileLazyQueryHookResult = ReturnType<typeof useNerdWalletUserProfileLazyQuery>;
export type NerdWalletUserProfileSuspenseQueryHookResult = ReturnType<typeof useNerdWalletUserProfileSuspenseQuery>;
export type NerdWalletUserProfileQueryResult = Apollo.QueryResult<NerdWalletUserProfileQuery, NerdWalletUserProfileQueryVariables>;
export const ClientCardDocument = gql`
    subscription clientCard($clientId: UUID!) {
  clientCard(data: {clientId: $clientId}) {
    id
    agentMedicareQuote {
      agentOffer
      cId
      countyName
      createdAt
      pin
      quoteId
      state
      userId
      zip
    }
    agentMedigapQuote {
      cId
      createdAt
      id
      updatedAt
      userId
    }
    medigapQuote {
      id
      createdAt
    }
    pdpQuote {
      id
    }
    countyName
    customAnswers
    email
    firstName
    lastName
    gender
    tobacco
    phoneNumber
    pin
    profileId
    quoteId
    status
    birthDate
    zip
    state
    scopeOfAppointmentStatus
  }
}
    `;

/**
 * __useClientCardSubscription__
 *
 * To run a query within a React component, call `useClientCardSubscription` and pass it any options that fit your needs.
 * When your component renders, `useClientCardSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientCardSubscription({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useClientCardSubscription(baseOptions: Apollo.SubscriptionHookOptions<ClientCardSubscription, ClientCardSubscriptionVariables> & ({ variables: ClientCardSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ClientCardSubscription, ClientCardSubscriptionVariables>(ClientCardDocument, options);
      }
export type ClientCardSubscriptionHookResult = ReturnType<typeof useClientCardSubscription>;
export type ClientCardSubscriptionResult = Apollo.SubscriptionResult<ClientCardSubscription>;
export const PatchClientPersonalInfoDocument = gql`
    mutation patchClientPersonalInfo($clientId: UUID!, $preferredDrugs: [PreferredDrugInput!], $preferredPharmacies: [String!], $drugDeliveryType: ClientDrugDeliveryType) {
  patchClientPersonalInfo(
    clientId: $clientId
    preferredDrugs: $preferredDrugs
    preferredPharmacies: $preferredPharmacies
    drugDeliveryType: $drugDeliveryType
  )
}
    `;
export type PatchClientPersonalInfoMutationFn = Apollo.MutationFunction<PatchClientPersonalInfoMutation, PatchClientPersonalInfoMutationVariables>;

/**
 * __usePatchClientPersonalInfoMutation__
 *
 * To run a mutation, you first call `usePatchClientPersonalInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePatchClientPersonalInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [patchClientPersonalInfoMutation, { data, loading, error }] = usePatchClientPersonalInfoMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      preferredDrugs: // value for 'preferredDrugs'
 *      preferredPharmacies: // value for 'preferredPharmacies'
 *      drugDeliveryType: // value for 'drugDeliveryType'
 *   },
 * });
 */
export function usePatchClientPersonalInfoMutation(baseOptions?: Apollo.MutationHookOptions<PatchClientPersonalInfoMutation, PatchClientPersonalInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PatchClientPersonalInfoMutation, PatchClientPersonalInfoMutationVariables>(PatchClientPersonalInfoDocument, options);
      }
export type PatchClientPersonalInfoMutationHookResult = ReturnType<typeof usePatchClientPersonalInfoMutation>;
export type PatchClientPersonalInfoMutationResult = Apollo.MutationResult<PatchClientPersonalInfoMutation>;
export type PatchClientPersonalInfoMutationOptions = Apollo.BaseMutationOptions<PatchClientPersonalInfoMutation, PatchClientPersonalInfoMutationVariables>;
export const CalendlyInviteeDocument = gql`
    query calendlyInvitee($eventUrl: String!, $inviteeUrl: String!) {
  calendlyInvitee(eventUrl: $eventUrl, inviteeUrl: $inviteeUrl) {
    email
    firstName
    lastName
    phone
  }
}
    `;

/**
 * __useCalendlyInviteeQuery__
 *
 * To run a query within a React component, call `useCalendlyInviteeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendlyInviteeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendlyInviteeQuery({
 *   variables: {
 *      eventUrl: // value for 'eventUrl'
 *      inviteeUrl: // value for 'inviteeUrl'
 *   },
 * });
 */
export function useCalendlyInviteeQuery(baseOptions: Apollo.QueryHookOptions<CalendlyInviteeQuery, CalendlyInviteeQueryVariables> & ({ variables: CalendlyInviteeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalendlyInviteeQuery, CalendlyInviteeQueryVariables>(CalendlyInviteeDocument, options);
      }
export function useCalendlyInviteeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalendlyInviteeQuery, CalendlyInviteeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalendlyInviteeQuery, CalendlyInviteeQueryVariables>(CalendlyInviteeDocument, options);
        }
export function useCalendlyInviteeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CalendlyInviteeQuery, CalendlyInviteeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CalendlyInviteeQuery, CalendlyInviteeQueryVariables>(CalendlyInviteeDocument, options);
        }
export type CalendlyInviteeQueryHookResult = ReturnType<typeof useCalendlyInviteeQuery>;
export type CalendlyInviteeLazyQueryHookResult = ReturnType<typeof useCalendlyInviteeLazyQuery>;
export type CalendlyInviteeSuspenseQueryHookResult = ReturnType<typeof useCalendlyInviteeSuspenseQuery>;
export type CalendlyInviteeQueryResult = Apollo.QueryResult<CalendlyInviteeQuery, CalendlyInviteeQueryVariables>;
export const UserProfileDocument = gql`
    query userProfile {
  userProfile {
    ...UserProfileFields
  }
}
    ${UserProfileFieldsFragmentDoc}`;

/**
 * __useUserProfileQuery__
 *
 * To run a query within a React component, call `useUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserProfileQuery(baseOptions?: Apollo.QueryHookOptions<UserProfileQuery, UserProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserProfileQuery, UserProfileQueryVariables>(UserProfileDocument, options);
      }
export function useUserProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserProfileQuery, UserProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserProfileQuery, UserProfileQueryVariables>(UserProfileDocument, options);
        }
export function useUserProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserProfileQuery, UserProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserProfileQuery, UserProfileQueryVariables>(UserProfileDocument, options);
        }
export type UserProfileQueryHookResult = ReturnType<typeof useUserProfileQuery>;
export type UserProfileLazyQueryHookResult = ReturnType<typeof useUserProfileLazyQuery>;
export type UserProfileSuspenseQueryHookResult = ReturnType<typeof useUserProfileSuspenseQuery>;
export type UserProfileQueryResult = Apollo.QueryResult<UserProfileQuery, UserProfileQueryVariables>;
export const AgentByIdDocument = gql`
    query agentById($id: UUID!) {
  agentById(id: $id) {
    b2bMeetingUrl
    email
    firstName
    id
    lastName
    picUrl
    phone
    enrollmentMeetingUrl
    planReviewUrl
    consultationUrl
  }
}
    `;

/**
 * __useAgentByIdQuery__
 *
 * To run a query within a React component, call `useAgentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAgentByIdQuery(baseOptions: Apollo.QueryHookOptions<AgentByIdQuery, AgentByIdQueryVariables> & ({ variables: AgentByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgentByIdQuery, AgentByIdQueryVariables>(AgentByIdDocument, options);
      }
export function useAgentByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgentByIdQuery, AgentByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgentByIdQuery, AgentByIdQueryVariables>(AgentByIdDocument, options);
        }
export function useAgentByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AgentByIdQuery, AgentByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AgentByIdQuery, AgentByIdQueryVariables>(AgentByIdDocument, options);
        }
export type AgentByIdQueryHookResult = ReturnType<typeof useAgentByIdQuery>;
export type AgentByIdLazyQueryHookResult = ReturnType<typeof useAgentByIdLazyQuery>;
export type AgentByIdSuspenseQueryHookResult = ReturnType<typeof useAgentByIdSuspenseQuery>;
export type AgentByIdQueryResult = Apollo.QueryResult<AgentByIdQuery, AgentByIdQueryVariables>;
export const AgentAssignedToClientDocument = gql`
    query agentAssignedToClient($clientId: UUID!) {
  agentAssignedToClient(clientId: $clientId) {
    email
    firstName
    id
    lastName
    picUrl
    phone
    enrollmentMeetingUrl
    planReviewUrl
    consultationUrl
  }
}
    `;

/**
 * __useAgentAssignedToClientQuery__
 *
 * To run a query within a React component, call `useAgentAssignedToClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentAssignedToClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentAssignedToClientQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useAgentAssignedToClientQuery(baseOptions: Apollo.QueryHookOptions<AgentAssignedToClientQuery, AgentAssignedToClientQueryVariables> & ({ variables: AgentAssignedToClientQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgentAssignedToClientQuery, AgentAssignedToClientQueryVariables>(AgentAssignedToClientDocument, options);
      }
export function useAgentAssignedToClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgentAssignedToClientQuery, AgentAssignedToClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgentAssignedToClientQuery, AgentAssignedToClientQueryVariables>(AgentAssignedToClientDocument, options);
        }
export function useAgentAssignedToClientSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AgentAssignedToClientQuery, AgentAssignedToClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AgentAssignedToClientQuery, AgentAssignedToClientQueryVariables>(AgentAssignedToClientDocument, options);
        }
export type AgentAssignedToClientQueryHookResult = ReturnType<typeof useAgentAssignedToClientQuery>;
export type AgentAssignedToClientLazyQueryHookResult = ReturnType<typeof useAgentAssignedToClientLazyQuery>;
export type AgentAssignedToClientSuspenseQueryHookResult = ReturnType<typeof useAgentAssignedToClientSuspenseQuery>;
export type AgentAssignedToClientQueryResult = Apollo.QueryResult<AgentAssignedToClientQuery, AgentAssignedToClientQueryVariables>;
export const SaveUserProfileDocument = gql`
    mutation saveUserProfile($data: UserProfileInput!) {
  saveUserProfile(input: $data) {
    enrollmentId
    profileId
    userId
    clientId
    userToken {
      accessToken
      idToken
      refreshToken
    }
  }
}
    `;
export type SaveUserProfileMutationFn = Apollo.MutationFunction<SaveUserProfileMutation, SaveUserProfileMutationVariables>;

/**
 * __useSaveUserProfileMutation__
 *
 * To run a mutation, you first call `useSaveUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUserProfileMutation, { data, loading, error }] = useSaveUserProfileMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSaveUserProfileMutation(baseOptions?: Apollo.MutationHookOptions<SaveUserProfileMutation, SaveUserProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveUserProfileMutation, SaveUserProfileMutationVariables>(SaveUserProfileDocument, options);
      }
export type SaveUserProfileMutationHookResult = ReturnType<typeof useSaveUserProfileMutation>;
export type SaveUserProfileMutationResult = Apollo.MutationResult<SaveUserProfileMutation>;
export type SaveUserProfileMutationOptions = Apollo.BaseMutationOptions<SaveUserProfileMutation, SaveUserProfileMutationVariables>;
export const SetNewPasswordDocument = gql`
    mutation setNewPassword($newPassword: String!) {
  setNewPassword(newPassword: $newPassword)
}
    `;
export type SetNewPasswordMutationFn = Apollo.MutationFunction<SetNewPasswordMutation, SetNewPasswordMutationVariables>;

/**
 * __useSetNewPasswordMutation__
 *
 * To run a mutation, you first call `useSetNewPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetNewPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setNewPasswordMutation, { data, loading, error }] = useSetNewPasswordMutation({
 *   variables: {
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useSetNewPasswordMutation(baseOptions?: Apollo.MutationHookOptions<SetNewPasswordMutation, SetNewPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetNewPasswordMutation, SetNewPasswordMutationVariables>(SetNewPasswordDocument, options);
      }
export type SetNewPasswordMutationHookResult = ReturnType<typeof useSetNewPasswordMutation>;
export type SetNewPasswordMutationResult = Apollo.MutationResult<SetNewPasswordMutation>;
export type SetNewPasswordMutationOptions = Apollo.BaseMutationOptions<SetNewPasswordMutation, SetNewPasswordMutationVariables>;
export const HasEnrollmentsDocument = gql`
    query hasEnrollments {
  hasEnrollments
}
    `;

/**
 * __useHasEnrollmentsQuery__
 *
 * To run a query within a React component, call `useHasEnrollmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasEnrollmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasEnrollmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useHasEnrollmentsQuery(baseOptions?: Apollo.QueryHookOptions<HasEnrollmentsQuery, HasEnrollmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HasEnrollmentsQuery, HasEnrollmentsQueryVariables>(HasEnrollmentsDocument, options);
      }
export function useHasEnrollmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HasEnrollmentsQuery, HasEnrollmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HasEnrollmentsQuery, HasEnrollmentsQueryVariables>(HasEnrollmentsDocument, options);
        }
export function useHasEnrollmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HasEnrollmentsQuery, HasEnrollmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HasEnrollmentsQuery, HasEnrollmentsQueryVariables>(HasEnrollmentsDocument, options);
        }
export type HasEnrollmentsQueryHookResult = ReturnType<typeof useHasEnrollmentsQuery>;
export type HasEnrollmentsLazyQueryHookResult = ReturnType<typeof useHasEnrollmentsLazyQuery>;
export type HasEnrollmentsSuspenseQueryHookResult = ReturnType<typeof useHasEnrollmentsSuspenseQuery>;
export type HasEnrollmentsQueryResult = Apollo.QueryResult<HasEnrollmentsQuery, HasEnrollmentsQueryVariables>;
export const MyEnrollmentsDocument = gql`
    query myEnrollments {
  myEnrollments {
    applicationDate
    bidId
    carrierName
    effectiveDate
    enrollmentType
    mgPlanKey
    mgPlanName
    naic
    planName
    planYear
    type
    id
    zip
    county
  }
}
    `;

/**
 * __useMyEnrollmentsQuery__
 *
 * To run a query within a React component, call `useMyEnrollmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyEnrollmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyEnrollmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyEnrollmentsQuery(baseOptions?: Apollo.QueryHookOptions<MyEnrollmentsQuery, MyEnrollmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyEnrollmentsQuery, MyEnrollmentsQueryVariables>(MyEnrollmentsDocument, options);
      }
export function useMyEnrollmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyEnrollmentsQuery, MyEnrollmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyEnrollmentsQuery, MyEnrollmentsQueryVariables>(MyEnrollmentsDocument, options);
        }
export function useMyEnrollmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyEnrollmentsQuery, MyEnrollmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyEnrollmentsQuery, MyEnrollmentsQueryVariables>(MyEnrollmentsDocument, options);
        }
export type MyEnrollmentsQueryHookResult = ReturnType<typeof useMyEnrollmentsQuery>;
export type MyEnrollmentsLazyQueryHookResult = ReturnType<typeof useMyEnrollmentsLazyQuery>;
export type MyEnrollmentsSuspenseQueryHookResult = ReturnType<typeof useMyEnrollmentsSuspenseQuery>;
export type MyEnrollmentsQueryResult = Apollo.QueryResult<MyEnrollmentsQuery, MyEnrollmentsQueryVariables>;